import React from "react";
import { Tile, fmtDate } from "./primitives";

export default function WebhooksPanel({ webhooks }) {
  return (
    <Tile
      title={`Recent Stripe webhooks (${webhooks.length})`}
      testid="tile-webhooks"
    >
      {webhooks.length === 0 ? (
        <div className="text-xs text-[#5C6B62]">No webhooks received yet.</div>
      ) : (
        <div className="space-y-1 max-h-48 overflow-y-auto">
          {webhooks.map((w, i) => (
            <div
              key={`${w.event_id || i}`}
              className="text-[11px] font-mono text-[#5C6B62] flex justify-between gap-2"
            >
              <span className="truncate">{w.event_type}</span>
              <span>{fmtDate(w.received_at)}</span>
            </div>
          ))}
        </div>
      )}
    </Tile>
  );
}
